import * as Api from '@ViewModels';
import { useMutation } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';

export function useContactDeleteKeepInTouchMutation({
	onSuccess,
	onError,
}: {
	onSuccess?: () => void;
	onError?: (error: Api.IOperationResultNoValue) => void;
} = {}) {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (
			keepInTouchId: string,
			{ impersonationContext }: { impersonationContext?: Api.IImpersonationContext } = {}
		) => {
			return userSession.webServiceHelper.callAsync<void>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `keepintouch/${keepInTouchId}`,
					impersonationContext,
				}),
				'DELETE'
			);
		},
		onSuccess,
		onError,
	});
}
